export const GET_DICTIONARY_ROLES = Symbol('GET_DICTIONARY_ROLES');
export const GET_DICTIONARY_ROLES_REQUEST = Symbol('GET_DICTIONARY_ROLES_REQUEST');
export const GET_DICTIONARY_ROLES_SUCCESS = Symbol('GET_DICTIONARY_ROLES_SUCCESS');
export const GET_DICTIONARY_ROLES_ERROR = Symbol('GET_DICTIONARY_ROLES_ERROR');

